/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_SaveInputs */

const en_us2_plan_build_dose_save = /** @type {(inputs: Plan_Build_Dose_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const pt_br2_plan_build_dose_save = /** @type {(inputs: Plan_Build_Dose_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

const es_419_plan_build_dose_save = /** @type {(inputs: Plan_Build_Dose_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const pt_pt2_plan_build_dose_save = /** @type {(inputs: Plan_Build_Dose_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const fr_fr2_plan_build_dose_save = /** @type {(inputs: Plan_Build_Dose_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_de2_plan_build_dose_save = /** @type {(inputs: Plan_Build_Dose_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_it2_plan_build_dose_save = /** @type {(inputs: Plan_Build_Dose_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Plan_Build_Dose_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_save = /** @type {((inputs?: Plan_Build_Dose_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_save(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_save(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_save(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_save(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_save(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_save(inputs)
	return en_us2_plan_build_dose_save(inputs)
});
export { plan_build_dose_save as "plan-build.dose_save" }